import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CiUnifiedSessionsService } from '@nimbus-portal/features/customer-insights/services/ci-unified-sessions.service';

@Injectable({ providedIn: 'root' })
export class CiCheckCustomerOverviewGuard implements CanActivate {
  public constructor(
    private readonly unifiedSessionsService: CiUnifiedSessionsService,
    private readonly router: Router,
  ) {}

  public canActivate(): Observable<boolean | UrlTree> {
    return this.unifiedSessionsService.isCustomerOverviewEnabled().pipe(map((isEnabled) => isEnabled || this.router.createUrlTree(['/'])));
  }
}
